export interface IActivity{
    sid: string,
    friendly_name: string
}

export class Activity{
    private sid: string
    private friendly_name: string 
    
    public get Sid() : string {
        return this.sid
    }
    
    public get Name() : string {
        return this.friendly_name
    }

    constructor(o: IActivity){
        this.sid = o.sid
        this.friendly_name = o.friendly_name
    }  

}